import {initElements} from "../define/shared"

export default function initDiscountBlock() {
    initElements(".ph-block.discount", block => {

        const close = block.querySelector('.closeBtn')
        const discountEl = block.querySelector('.discount-code-inner')

        if (discountEl) {
            discountEl.addEventListener('click', function () {
                navigator.clipboard.writeText(discountEl.querySelector('.discount-code-text').innerText);
            })
        }

        close.addEventListener('click', () => {
            block.classList.add('is-closed')
        })

        setTimeout(() => {
            block.classList.remove('is-closed')
        }, 5000)
    })
}
